export default defineNuxtPlugin(() => {
  const {status} = useAuth();

  const router = useRouter();
  const route = useRoute();

  watch(status, (status) => {
    // Force reload of route when the session becomes unauthenticated. This will ensure the auth middleware(s) are
    // executed again and the user is routed to the proper page.
    if (status === 'unauthenticated' && route) {
      router.replace({
        ...route,
        force: true,
      });
    }
  });
});
